// Abstract class for implementing Mapbox controls. Only
// requirement is to implement the _eventHandler method.
//
export default class BaseControl {
  constructor(options = {}) {
    this._className = options.className;
    this._title = options.title;
    this._innerHTML = options.innerHTML;
  }

  onAdd(map) {
    this._map = map;
    this._btn = document.createElement("button");
    this._btn.className = this._className;
    this._btn.innerHTML = this._innerHTML;
    this._btn.type = "button";
    this._btn.title = this._title;
    this._btn.addEventListener("click", (event) => { this._eventHandler(event) });

    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._btn);
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }

  enable() {
    this._btn.disabled = false;
  }

  disable() {
    this._btn.disabled = true;
  }
}
